import { memo } from 'react';
import { Card } from 'react-bootstrap';

function getStatusBadge(status) {
  if (status === 'arrived') {
    return { bg: '#0284c7', color: '#ffffff', label: 'Na Sala' };
  }
  if (status === 'done') {
    return { bg: '#059669', color: '#ffffff', label: 'Atendido' };
  }
  return { bg: '#dc2626', color: '#ffffff', label: 'CHAMANDO' };
}

function CardSalaComponent({ nomeSala, call, medicoTitular }) {
  const hasCall = Boolean(call);
  const isCalling = hasCall && call.status === 'calling';
  const isArrived = hasCall && call.status === 'arrived';
  const badgeInfo = hasCall ? getStatusBadge(call.status) : null;

  return (
    <Card
      className="border-0 rounded-4 p-2 h-100 d-flex flex-column justify-content-between"
      style={{
        backgroundColor: isCalling ? '#fef2f2' : isArrived ? '#f0f9ff' : '#ffffff',
        border: isCalling
          ? '4px solid #dc2626'
          : isArrived
            ? '3px solid #0284c7'
            : '1px solid #e2e8f0',
        boxShadow: '0 2px 4px 0 rgba(0,0,0,0.03)',
      }}
    >
      {/* Cabeçalho da Sala */}
      <div className="d-flex justify-content-between align-items-center mb-1">
        <span
          className="fw-black text-uppercase"
          style={{
            fontSize: '3.0rem',
            lineHeight: '1',
            fontWeight: 900,
            color: isCalling ? '#dc2626' : isArrived ? '#0369a1' : '#0f172a',
          }}
        >
          {nomeSala}
        </span>

        {hasCall && badgeInfo && (
          <span
            className="px-3 py-1 rounded-pill fw-bold text-uppercase"
            style={{
              backgroundColor: badgeInfo.bg,
              color: badgeInfo.color,
              fontSize: '1.85rem',
              letterSpacing: '0.5px',
            }}
          >
            {badgeInfo.label}
          </span>
        )}
      </div>

      {/* Conteúdo Central - Paciente ou Estado LIVRE */}
      <div className="my-auto py-1" style={{ minWidth: 0, width: '100%' }}>
        {hasCall ? (
          <div style={{ minWidth: 0, width: '100%', overflow: 'hidden' }}>
            <div
              className="fw-bold text-uppercase mb-1"
              style={{
                fontSize: '0.75rem',
                color: '#64748b',
                letterSpacing: '0.5px',
              }}
            >
              PACIENTE
            </div>

            {/* FORÇA 1 LINHA ÚNICA COM RETICÊNCIAS (...) */}
            <div
              className="nome-paciente-tv fw-bold text-uppercase"
              style={{
                display: 'block',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                maxWidth: '100%',
                width: '100%',
                fontSize: '3.0rem',
                lineHeight: '1.1',
              }}
              title={call?.nomepac}
            >
              {call?.nomepac || 'Aguardando...'}
            </div>

            <div
              className="mt-2 pt-2 border-top border-slate-200"
              style={{ minWidth: 0, width: '100%' }}
            >
              <span
                className="text-slate-400 fw-bold"
                style={{
                  display: 'block',
                  fontSize: '2.4rem',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '100%',
                  width: '100%',
                }}
              >
                {call.NOMEMEDICO || ''}
              </span>
            </div>
          </div>
        ) : (
          <div className="d-flex align-items-center justify-content-center h-100 py-3">
            <span
              className="fw-bold text-uppercase tracking-wider"
              style={{ color: '#000', fontSize: '2.2rem' }}
            >
              {medicoTitular}
            </span>
          </div>
        )}
      </div>

      {/* Rodapé do Card */}
      {hasCall && (
        <div className="d-flex justify-content-between align-items-center mt-2 pt-1">
          {call.isRecalled ? (
            <span
              className="badge bg-danger text-white fw-bold px-2 py-1"
              style={{ fontSize: '0.75rem' }}
            >
              ⚠️ RECHAMADA
            </span>
          ) : (
            <span />
          )}
        </div>
      )}
    </Card>
  );
}

export const CardSala = memo(CardSalaComponent);
